import React from "react";
import ReactDOM from "react-dom";
// import 'rsuite/dist/styles/rsuite-default.css';
import "./index.css";
import App from "./components/App";
import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.css";
import $ from "jquery";
import Popper from "popper.js";
import "bootstrap/dist/js/bootstrap.bundle.min";
import * as Sentry from "@sentry/react";
import * as axios from "../src/core/services/axios";
import { Provider } from "react-redux";
import store from "./core/redux/store";
import { createRoot } from "react-dom/client";
import LocalStorageService from "./core/services/local-storage.service";
const localStorageService = LocalStorageService.getService();
let userDetails = localStorageService.getUserDetails();

includeSentry();

function includeSentry() {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_KEY,
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
      }),
      new Sentry.Replay(),
    ],
    release: process.env.REACT_APP_BRANCH + "_" + process.env.REACT_APP_COMMIT_ID,
    initialScope: (scope) => {
      scope.setTags({ userDetails: JSON.stringify({ userDetails: JSON.stringify(userDetails.email_address) }) });
      return scope;
    },
    environment: process.env.REACT_APP_HOST_ENV ? process.env.REACT_APP_HOST_ENV : process.env.NODE_ENV,
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
